import { render, staticRenderFns } from "./PromotionalComponentOctober.vue?vue&type=template&id=f7ad527c"
import script from "./PromotionalComponentOctober.vue?vue&type=script&lang=js"
export * from "./PromotionalComponentOctober.vue?vue&type=script&lang=js"
import style0 from "./PromotionalComponentOctober.vue?vue&type=style&index=0&id=f7ad527c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports